import { Permission } from '@/api';
import { BaseModal } from '@/components/base-modal';
import { useErrorNotification } from '@/hooks/use-error-notification';
import { useHasPermissions } from '@/hooks/use-has-permissions';
import { useNotification } from '@/hooks/use-notification';
import { useFlowhavenUpdate } from '@/pages/queries';
import { Text } from '@lego/klik-ui';
import type { RefObject } from 'react';

type FlowhavenModalProps = {
  isOpen: boolean;
  triggerRef: RefObject<HTMLElement | null>;
  onClose: () => void;
};

const FlowhavenModal = ({
  isOpen,
  triggerRef,
  onClose,
}: FlowhavenModalProps) => {
  const hasPermission = useHasPermissions([Permission.ManageLelPrices]);
  const showNotification = useNotification();
  const showErrorNotification = useErrorNotification();
  const { mutate: updatePrices, isPending } = useFlowhavenUpdate(
    (numberOfUpdatedPrices) => {
      showNotification({
        title: 'Prices updated',
        description:
          numberOfUpdatedPrices === 1
            ? `Successfully updated ${numberOfUpdatedPrices} LEL price from Flowhaven.`
            : `Successfully updated ${numberOfUpdatedPrices} LEL prices from Flowhaven.`,
        type: 'success',
      });
      onClose();
    },
    (error) => showErrorNotification(error, 'update prices from Flowhaven'),
  );
  return (
    <BaseModal
      isOpen={isOpen}
      triggerRef={triggerRef}
      onClose={onClose}
      title="Update from Flowhaven?"
      rightButtonProps={{
        text: 'Update Prices',
        onClick: () => updatePrices(),
        loading: isPending,
        disabled: !hasPermission,
      }}
    >
      <Text className="body-md-medium">
        This will automatically sync LEL prices from Flowhaven.{' '}
        <b>This action can't be undone.</b>
      </Text>
    </BaseModal>
  );
};
export default FlowhavenModal;
